import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {UserContext} from '../../_context/user.context';
import {SharedService} from '../shared.service';
import {Constants} from '../Helpers/constants';
import {UserService} from '../../_services';
import {tap} from 'rxjs/internal/operators/tap';
import {Observable} from 'rxjs/internal/Observable';
import {Router} from '@angular/router';
import {AbleExpiryPasswordSettings} from '../interfaces';

@Component({
  selector: 'password-expiry',
  templateUrl: './password-expiry.component.html'
})
export class PasswordExpiryComponent implements OnInit {
  @Input() public manageSelf: boolean = false;
  @Input() public passwordExpirySettings: AbleExpiryPasswordSettings = {}
  @Input() userLogged: any;
  @Input() public hostName: string
  @Input() public returnUrl: string;
  @Input() public triggerGetPeople$: Observable<any>
  @Output() close = new EventEmitter<any>();
  @Output() skip = new EventEmitter<any>();
  @Output() checkForSaml = new EventEmitter<any>();
  @Output() reset = new EventEmitter<any>();
  public triggerObs$: Observable<any>


  public user: any;
  public logoPath: any;
  constructor(
    public sharedService: SharedService,
    private userService: UserService,
    private router: Router
  ) {

  }
  ngOnInit(): void {
    if (this.passwordExpirySettings?.passwordDaysExpire <= 0) {
      this.passwordExpirySettings.hasExpired = true;
    }
    if (this.passwordExpirySettings.hasExpired) {
      this.user = new UserContext();
    }
    if (this.manageSelf) {
      this.triggerObs$ = this.triggerGetPeople$.pipe(
        tap(value => {
          if (value)
            this.getPeopleData()
        })
      )
    }
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath =  Constants.logoPath;
      }
    } else {
      this.logoPath =  Constants.logoPath;
    }
  }

  onSkip() {
    this.skip.emit();
    if (this.manageSelf) {
      this.passwordExpirySettings.passwordExpiry = false
      this.checkForSaml.emit()
    }
  }

  onReset() {
    this.reset.emit();
    if (this.manageSelf) {
      this.passwordExpirySettings.passwordExpiry = false;
      this.router.navigate(['reset-password']);
    }
  }
  private  getPeopleData() {
    const currentUser = new UserContext();
    if (currentUser.isAuthenticated) {
      this.userService.getPeopleById(currentUser.personID).subscribe({
        next: (res) => {
          this.userLogged = res.body;
          this.passwordExpirySettings.firstLoginDataPeople = this.userLogged.firstLoginDate;
          this.checkPasswordExpiry();
        },
        error: (err) => {
          if (err.status === 0) {
            this.passwordExpirySettings.checkFirstLogin = false;
            this.passwordExpirySettings.controlPasswordExpired = true;
            this.passwordExpirySettings.hasExpired = true;
            this.userLogged = {};
            this.passwordExpirySettings.passwordExpiry = true;

          } else if (err.status === 401) {
            if (err.error.errorCode === 1012) {
              this.passwordExpirySettings.checkFirstLogin = true;
            } else if (err.error.errorCode === 1010) {
              this.passwordExpirySettings.checkFirstLogin = false;
            }
            this.sharedService.storeFirstLoginForExpiryPassword(this.passwordExpirySettings.checkFirstLogin);
            this.passwordExpirySettings.controlPasswordExpired = true;
            this.passwordExpirySettings.hasExpired = true;
            this.user = new UserContext()
            this.userLogged = {};
            this.passwordExpirySettings.passwordExpiry = true;
          }
        }
      });
    }
  }
  private checkPasswordExpiry() {
    // check if password expired date is less than 7 days.
    // Get the current date
    const todayDate = new Date();
    // Set start/end dates to a specified date
    const expiryDate = new Date(this.userLogged.passwordExpiryDate);

    // Compare the two dates
    const duration = Math.floor((Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate())
      - Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate())) / (1000 * 60 * 60 * 24));

    this.passwordExpirySettings.passwordDaysExpire = duration;

    if (this.passwordExpirySettings.passwordDaysExpire <= 7) {
      this.userService.checkPeopleLastAccess(this.userLogged.id).subscribe({
        next: (data) => {
          const checkLastAccess = data.body;

          if (checkLastAccess.shouldDisplayMessage) {
            if (duration <= 7 && duration > 2) {
              this.passwordExpirySettings.controlPasswordExpired = true;
              this.passwordExpirySettings.passwordExpiry = true;
              // show popup to reset password or to skip it
            } else if (duration <= 2) {
              if (duration <= 0) {
                this.passwordExpirySettings.controlPasswordExpired = true;
                this.passwordExpirySettings.hasExpired = true;
                this.passwordExpirySettings.passwordExpiry = true;
              } else {
                this.passwordExpirySettings.controlPasswordExpired = true;
                this.passwordExpirySettings.passwordExpiry = true;
              }
            } else {
              this.checkForSaml.emit();
            }
          } else {
            if (duration <= 2) {
              if (duration <= 0) {
                this.passwordExpirySettings.controlPasswordExpired = true;
                this.passwordExpirySettings.hasExpired = true;
                this.passwordExpirySettings.passwordExpiry = true;
              } else {
                this.passwordExpirySettings.controlPasswordExpired = true;
                this.passwordExpirySettings.passwordExpiry = true;
              }
            } else {
              this.checkForSaml.emit();
            }
          }
        },
        error: (err) => {
          console.log(err)
        }
      });
    } else {
      if (this.passwordExpirySettings.firstLoginDataPeople > this.passwordExpirySettings.currentLoginDate) {
        this.getOrganisationIdByHomeUser();
      } else {
        this.checkForSaml.emit();
      }
    }
  }

  getOrganisationIdByHomeUser() {
    this.userService.getHomeUser(this.userLogged.id).subscribe((userData) => {
      const filterUser = userData.body.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id)
    });
  }
}
